import { isAlternateDomain } from '@/utils/domainUtils';
import { PLAN_5_LEVELS, PLAN_10_LEVELS, type ReferralPlan } from '@/config/referralPlans';

export const useReferralPlan = (): ReferralPlan => {
  return isAlternateDomain() ? PLAN_5_LEVELS : PLAN_10_LEVELS;
};
